<template>
  <div class="coupon-wrapper">
    <div>
      <img src="https://platform-oss.oss-cn-qingdao.aliyuncs.com/image/qdt/home/qde.jpg" alt="" width="100%">
    </div>
    <div @click="goMini" class="bottom"></div>
  </div>
</template>

<script>
import { setStore } from '@/utils/index'
export default {
  data () {
    return {
    }
  },
  mounted () {

  },
  methods: {
    goMini () {
      let item = {
        finishCurrentPage: 0,
        appId: '100299999',
        authorize: 0,
        appStartUrl: 'pages/h5/h5?url=https%3A%2F%2Fqdhmb.shie.com.cn%2F%23%2F%3FbusiDomainCode%3DQD-YL-10182%26agentID%3Da6f9f8acc3bd4501',
        androidGoPage: 'gh_89eafadfce80',
        iosGoPage: 'gh_89eafadfce80',
        appType: 3,
        goPage: 'gh_89eafadfce80'
      }

      window.ReactNativeWebView.postMessage(JSON.stringify(item))
    }
  }
}

</script>
<style lang='scss' scoped>

.coupon-wrapper {
  position: relative;
  min-height: 100vh;
  img {
    display: block;
    width: 100%;
  }
  .intro-tip {
    position: absolute;
    top: 32.5%;
    width: 100%;
    height: 4%;
  }
  .intro-tip-2 {
    position: absolute;
    top: 36.7%;
    width: 100%;
    height: 4%;
  }
  .bottom {
    position: absolute;
    bottom: 5%;
    width: 100%;
    height: 20%;
  }
}

</style>
